<template>
  <div style="text-align: right; margin: 40px;">
    <div class="uk-inline">
      <img :style="imageStyle" :src="url">
      <div class="uk-position-bottom-left" uk-parallax="y: -100,0; viewport: 0;">
        <div style="margin-left: 10px">
          {{caption}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageMeta from '../ImageMeta.js'
export default {
  name: 'main',
  props: ['topic', 'subtopic', 'number'],
  data () {
    return {
      activeTab: 0,
      imageStyle: {
        maxHeight: '' + window.innerHeight + 'px',
        maxWidth: '100%', // '' + window.innerWidth + 'px',
        margin: 'auto'
      }
    }
  },
  computed: {
    caption: function () {
      return ImageMeta[this.topic][this.subtopic].examples[this.number].caption
    },
    url: function () {
      return 'static/imgs/' + ImageMeta[this.topic][this.subtopic].examples[this.number].url
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/LessonImage.vue